import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const uploadFileV2Migration: PropsMigration = {
  mode: 'props',
  description: 'UploadFile v2 Migration: Migrate font.bold style to font.weight',
  run: (props: PartialPropsOf<'uploadFile'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.style?.upload?.font);
  },
};
